import { clients } from '@moovly/clients';
import { GroupEventsResponse } from '@moovly/clients/lib/resources/bi/bi.interfaces';
import { createAsyncThunk, createListenerMiddleware, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DefaultApiRequestState,
  getDefaultApiRequestState,
  getDefaultReducerForAsyncRequest,
  RequestType,
} from '../../../store/default';
import { RootState } from '../../../store/rootStore';
import { eventTypes } from '../configs/events';
let cursorsBusy: any = {};
export const getLogs: any = createAsyncThunk<any, any, { state: RootState }>(
  'dashboard/logs/getLogs',
  async (
    {
      groupId,
    }: {
      groupId: string;
    },
    { getState }
  ) => {
    const { logs } = getState();
    const cursor = logs.logs.data?.cursor || null;
    if (!cursorsBusy[groupId]) {
      cursorsBusy[groupId] = [];
    }
    if (cursorsBusy[groupId].includes(cursor)) {
      return null;
    }

    cursorsBusy[groupId].push(cursor);

    const filter = logs.filter;
    const filterTypes = !!filter.types.length ? filter.types : eventTypes;
    return await clients.BI.getGroupEvents(groupId, {
      page_size: 100,
      expands: filterTypes,
      cursor,
    }).catch((e) => {
      cursorsBusy = cursorsBusy[groupId].filter((c: any) => c !== cursor);
      throw e;
    });
  }
);

type FilterOptions = {
  types: string[];
};

type LogsState = {
  logs: DefaultApiRequestState<
    GroupEventsResponse & FilterOptions,
    [RequestType.Get, RequestType.Post, RequestType.Put, RequestType.Delete]
  >;
  filter: FilterOptions;
};

const initialState: LogsState = {
  logs: {
    ...getDefaultApiRequestState([RequestType.Get]),
  },
  filter: { types: [] },
};

export const logsSlice = createSlice({
  name: 'logs',
  initialState,
  reducers: {
    reset: () => {
      cursorsBusy = {};
      return initialState;
    },
    setLogsFilter: (state, { payload }: PayloadAction<FilterOptions>) => {
      cursorsBusy = {};

      state.filter = payload;
      state.logs.data = null;
    },
  },
  extraReducers: {
    ...getDefaultReducerForAsyncRequest({
      thunk: getLogs,
      getInitialState: (state) => state.logs,
      requestType: RequestType.Get,
      onSuccess: (state, payload) => {
        if (!payload) {
          return;
        }
        state.data = !state.data
          ? payload
          : {
              count: payload.count,
              cursor: payload.cursor,
              results: [...state.data.results, ...payload.results],
            };
      },
    }),
  },
});

export const logsMiddleware = createListenerMiddleware();

logsMiddleware.startListening({
  actionCreator: getLogs.fulfilled,
  effect: (action, listenerApi) => {
    if (action.payload) {
      const state = listenerApi.getState() as RootState;
      const { results, count } = state.logs.logs.data || { count: 0 };
      if (results && results.length < 20 && results.length < count) {
        listenerApi.dispatch(getLogs(action.meta.arg));
      }
    }
  },
});

export const { setLogsFilter } = logsSlice.actions;
export default logsSlice;
